<template>
  <ul class="reviewRating" :class="ratingClass">
    <li class="star" @click="set(1)" :class="{starFilled: review >= 1}"></li>
    <li class="star" @click="set(2)" :class="{starFilled: review >= 2}"></li>
    <li class="star" @click="set(3)" :class="{starFilled: review >= 3}"></li>
    <li class="star" @click="set(4)" :class="{starFilled: review >= 4}"></li>
    <li class="star" @click="set(5)" :class="{starFilled: review >= 5}"></li>
  </ul>
</template>
<script>
export default {
  props: {
    ratingClass: {
      type: Object,
      default: {}
    },
    editReview: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data() {
    return {
      review: 0
    };
  },
  mounted() {
    if (this.editReview) {
      this.review = this.editReview
    }
  },
  methods: {
    set(value) {
      this.review = value;
      this.$emit('input', value);
    }
  },
  watch: {},
};
</script>

<style lang="scss">
.reviewRating.error {
  margin-bottom: 2rem !important;
  + p {
    margin-bottom: 2rem !important;
  }
}
</style>
